module.exports = __webpack_public_path__ + "img/face.70443bb9.png";